import { useApi } from '../../lib/useApi';
import { useKanzlei } from '../context';
import type { ClientRow, Registrations } from './types';

// Offene und abgelehnte Registrierungen (nur Admin; für alle anderen wird nichts geladen).
export function useRegistrations() {
  const { me } = useKanzlei();
  return useApi<Registrations>(me.user.isAdmin ? '/api/kanzlei/registrations' : null, { live: ['clients'] });
}

// Sichtbare Mandanten (Admin alle, Mitarbeiter zugewiesene), live bei Zuweisungen und Änderungen
export function useClientList() {
  return useApi<{ clients: ClientRow[] }>('/api/kanzlei/clients', { live: ['clients', 'team'] });
}
